import { render, staticRenderFns } from "./ToolsTreeMenu.vue?vue&type=template&id=794b3976&scoped=true&lang=pug&"
import script from "./ToolsTreeMenu.vue?vue&type=script&lang=ts&"
export * from "./ToolsTreeMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b3976",
  null
  
)

export default component.exports